var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    viewBox: "0 0 97 25",
    stroke: "currentColor",
    strokeWidth: 1,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mini-TMQ logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M 2 20.25 v -19 l 6.3 11.8 l 6.3 -11.8 v 19     m 5.45 0 v -11.75 m 0 -5.75 v -.5     m 5.05 18 v -11.75 m 0 3.2 a 4.475 4.475 0 0 1 8.7 0 v 8.55     m 4.9 0 v -11.75 m 0 -5.75 v -.5     m 4.6 11.9 h 7.1     m 1.6 -13.05 h 11 m -5.5 0 v 19.1     m 9.4 0 v -19 l 6.3 11.8 l 6.3 -11.8 v 19     m 5.7 -3.65 v -11.55 a 5.05 4.85 0 0 1 9.9 0 v 11.55 a 5.05 4.85 0 0 1 -9.9 0     m 4.95 1 v 5.8   "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dc15811528793f0780abf53103e4b49b.svg";
export { ForwardRef as ReactComponent };